import axios from 'axios'

class shopifyGraphQL {
  /***
   *
   */
  async get(queryString) {
    const STOREFRONT_ACCESS_TOKEN = '7c4f27bb0f50ae71ba28b71fc030668c'
    const GRAPHQL_URL = 'https://idylus.myshopify.com/api/2022-10/graphql.json'

    const promise = new Promise((resolve) => {
      axios({
        url: GRAPHQL_URL,
        async: true,
        crossDomain: true,
        method: 'POST',
        headers: {
          'X-Shopify-Storefront-Access-Token': STOREFRONT_ACCESS_TOKEN,
          'Content-Type': 'application/graphql',
        },
        data: queryString,
      }).then((response) => {
        resolve(response.data)
      })
    })

    return await promise
  }
}

export default new shopifyGraphQL()
